import { VStack, Text, HStack, Box, Button } from '@chakra-ui/react';
import { AddPeopleIcon } from 'assets/icons/v2';
import { PageContext } from 'components/common/PageContext';
import { NovaIcon } from 'components/ui/novaIcon';
import { ReactElement } from 'react';

type registrationLayoutProps = {
  children: React.ReactNode;
  handleInviteClick: () => void;
  pageTitle: string;
  tabTitle: string;
  inviteButtonText?: string;
  inviteIcon?: ReactElement;
};

export const OrganizationManagementLayout = ({
  children,
  handleInviteClick,
  pageTitle,
  tabTitle,
  inviteButtonText = 'Einladen',
  inviteIcon = <NovaIcon icon={AddPeopleIcon} size="m" color="icon.onAccent" />,
}: registrationLayoutProps): ReactElement => {
  return (
    <PageContext title={tabTitle} hasBackButton headTitle={tabTitle}>
      <Box height="100%" minHeight="100%" flexDirection="column" maxWidth="100%" flexGrow={1}>
        <VStack
          bg="background.primary"
          align="left"
          p={{ base: '20px 28px' }}
          margin={{ md: '40px 0' }}
          gap={{ base: '40px' }}
          width="100%"
          borderRadius={{ md: '2xl' }}
        >
          <HStack justify="space-between" align="center" w="full" gap="l">
            <Text textStyle="h3.medium" color="text.primary">
              {pageTitle}
            </Text>
            <Button variant="primary" onClick={handleInviteClick}>
              {inviteIcon}
              {inviteButtonText}
            </Button>
          </HStack>
          {children}
        </VStack>
      </Box>
    </PageContext>
  );
};
